import { useEffect, useState } from 'react'
import { Icon, Form, Button, Radio } from 'semantic-ui-react'
import { DistributorService, HelperService, MobileMoneyServiceService, PartnerService } from '../services'
import { CashReception, MobileMoney, Partner } from '../models'
import { ErrorMessage } from './error-message'
import { FeedbackMessage, DropdownOptions } from '../constants'

const inlineStyle = {
    wrapper: {
        padding: '20px',
        borderRadius: '5px',
        backgroundColor: '#f9fafb',
        minHeight: '240px',
        border: '1px solid #d4d4d5',
    },
    step: {
        display: 'flex',
        justifyContent: 'center',
        height: '160px',
        paddingTop: '15px',
    }
}

export function DistributorCashReceptionForm({ addToList }: { addToList: Function }) {

    const [step, setStep] = useState(1)
    const [source, setSource] = useState('')
    const [amount, setAmount] = useState('')
    const [sourceId, setSourceId] = useState('')
    const [moneyType, setMoneyType] = useState('')
    const [comments, setComments] = useState('')
    const [creating, setCreating] = useState(false)
    const [error, setError] = useState(false)
    const [partners, setPartners] = useState<Partner[]>([])
    const [mobileMoneyServices, setMobileMoneyServices] = useState<MobileMoney[]>([])


    useEffect(() => {

        getMobileMoneyServiceList()

        getPartnersList()

    }, [])


    const sourceOptions = [
        { key: 'b', text: 'Banque', value: 'bank' },
        { key: 'p', text: 'Partenaire', value: 'partner' },
    ]

    const handleNext = () => {

        if (step === 1 && source === '')

            return alert('Veuillez choisir l\'origine des fonds')

        if (step === 2) {

            if (sourceId === '') return alert('Veuillez choisir le pourvoyeur des fonds')

            if (moneyType === '') return alert('Veuillez choisir la nature des fonds')
        }

        setStep(step => step + 1)
    }

    const handlePartnerChange = (e: any, data: any) => setSourceId(data.value)

    const handleServiceChange = (e: any, data: any) => { 
      
        setSourceId(data.value)

        setMoneyType(e.target.textContent)

    }

    const handleMoneyTypeChange = (e: any, data: any) => setMoneyType(data.value)


    const getMobileMoneyServiceList = () => {

        MobileMoneyServiceService.getMobileMoneyServices()
            .then(data => setMobileMoneyServices(data))
            .catch(err => setError(true))
            .finally(() => { })
    }

    const getPartnersList = () => {

        PartnerService.getPartners()
            .then(data => setPartners(data))
            .catch(err => setError(true))
            .finally(() => { })
    }

    const handleFormSubmit = () => {

        if (amount === '')

            return alert('Veuillez entrer le montant des fonds')

        if (!HelperService.isInteger(amount) || Number(amount) <= 0)

            return alert('Le montant doit être un nombre supérieur à zéro')

        setCreating(true)

        const cr = new CashReception({
            sourceType: source,
            sourceId: parseInt(sourceId),
            moneyType: moneyType,
            amount: parseInt(amount),
            comments: comments
        })

        DistributorService.createCashReception(cr)
            .then(data => {
                reinitForm()
                addToList(data)
            })
            .catch(err => setError(true))
            .finally(() => setCreating(false))
    }

    const reinitForm = () => {
        setStep(1)
        setSource('')
        setAmount('')
        setComments('')
    }

    return <div style={inlineStyle.wrapper}>

        {error && <ErrorMessage errorText={FeedbackMessage.CASH_RECEPTION_CREATE_ERROR} />}

        <Form>
            {step === 1 &&
                <div style={inlineStyle.step}>
                    <div style={{ width: '500px' }}>
                        <h3>Étape 1: Choisir l'origine des fonds</h3>
                        <br />
                        <div className='flex space-between'>
                            <Radio
                                label='Un service de mobile money'
                                name='radioGroup'
                                value='service'
                                checked={source === 'service'}
                                onChange={_ => setSource('service')}
                            />

                            <Radio
                                label='Un partenaire de la société'
                                name='radioGroup'
                                value='partner'
                                checked={source === 'partner'}
                                onChange={_ => setSource('partner')}
                            />
                        </div>
                    </div>
                </div>
            }

            {step === 2 &&
                <div style={inlineStyle.step}>
                    <div style={{ width: '400px' }}>

                        <h3>Étape 2: Pourvoyeur & nature des fonds</h3>
                        {
                            source === 'partner' &&
                            <>
                                <Form.Select
                                    fluid
                                    options={partners.map(p => ({ key: p.id, text: p.name, value: p.id }))}
                                    placeholder='Choisir le partenaire'
                                    value={sourceId}
                                    onChange={handlePartnerChange}
                                />

                                <Form.Select
                                    fluid
                                    options={DropdownOptions.moneyTypeOptions}
                                    placeholder="Choisir la nature des fonds"
                                    value={moneyType}
                                    onChange={handleMoneyTypeChange}
                                />
                            </>
                        }

                        {
                            source === 'service' &&
                            <Form.Select
                                fluid
                                options={mobileMoneyServices.map(m => {
                                    if (m.bank)
                                        return ({ key: m.id, text: m.name + (m.bank ? ' --> ' : '') + m.bank, value: m.id })
                                    else
                                        return ({ key: m.id, text: m.name, value: m.id  })

                                })}
                                placeholder='Choisir le service de mobile money'
                                value={sourceId}
                                onChange={handleServiceChange}
                            />
                        }


                    </div>
                </div>
            }

            {step === 3 &&
                <div style={inlineStyle.step}>
                    <div style={{ width: '400px' }}>
                        <h3>Montant des fonds (cfa)</h3>
                        <Form.Input
                            fluid
                            options={sourceOptions}
                            placeholder='montant reçu'
                            value={amount}
                            onChange={e => setAmount(e.target.value)}
                        />

                        <Form.TextArea
                            value={comments}
                            rows={3}
                            placeholder='Commentsaire optionnel'
                            onChange={e => setComments(e.target.value)}
                        />
                    </div>
                </div>
            }

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {step < 3 && <Button color='black' onClick={handleNext}> Suivant <Icon name='long arrow alternate right' /></Button>}
                {step === 3 && <Button color='black' content="Confirmer" onClick={handleFormSubmit} loading={creating} />}
            </div>
        </Form>
    </div>
}
